import React from 'react'
import { Box, Typography, Container } from '@mui/material'
import Navbar from '../../../shared/Navbar'
import AppleLuckyDrawForm from './AppleLuckyDrawForm'

const AppleLuckyDraw = () => (
  <Container component='main'>
    <Navbar />
    <Box textAlign='center' mt={12} mb={8}>
      <Typography
        sx={{
          fontSize: { xs: '30px', md: '50px' },
          fontFamily: 'Corsica LX Bold',
          lineHeight: 1,
        }}
      >
        Win Apple Product
      </Typography>
    </Box>
    <Box m={2} mb={8}>
      <AppleLuckyDrawForm></AppleLuckyDrawForm>
      <Box mt={3} pb={8} textAlign='center'>
        <Typography variant='h4'>
          For any enquiries, please reach out to us on{' '}
          <a
            style={{ color: '#002984' }}
            href='https://www.facebook.com/VartaAutomotiveMalaysia'
            target='_blank'
            rel='noopener noreferrer'
          >
            Facebook
          </a>
          .
        </Typography>
      </Box>
    </Box>
  </Container>
)

export default AppleLuckyDraw
